export const CREATE_SERVICE_USER_ACTIVITIES = "CREATE_SERVICE_USER_ACTIVITIES";   
export const RETRIEVE_SERVICE_USER_ACTIVITIES = "RETRIEVE_SERVICE_USER_ACTIVITIES";
export const RETRIEVESINGLE_SERVICE_USER_ACTIVITIES = "RETRIEVESINGLE_SERVICE_USER_ACTIVITIES";
export const UPDATE_SERVICE_USER_ACTIVITIES = "UPDATE_SERVICE_USER_ACTIVITIES";   
export const DELETE_SERVICE_USER_ACTIVITIES = "DELETE_SERVICE_USER_ACTIVITIES";   
